import React from 'react';
import { Header as HeaderStyled } from './index.styled';
import Topbar from './Topbar/index';

export const Header = () => (
    <HeaderStyled>
        <Topbar />
    </HeaderStyled>
);
